const isDev = process.env.NODE_ENV !== "production";

const hasGtag = () =>
  typeof window !== "undefined" && typeof window.gtag === "function";

export const gaEvent = (eventName, params = {}) => {
  if (isDev) {
    // eslint-disable-next-line no-console
    console.log(`[GA4] event: ${eventName}`, params);
  }
  if (!hasGtag()) return;
  window.gtag("event", eventName, params);
};

export const gaPageView = (path) => {
  const payload = {
    page_path: path,
    page_location: typeof window !== "undefined" ? window.location.href : "",
    page_title: typeof document !== "undefined" ? document.title : "",
  };
  if (isDev) {
    // eslint-disable-next-line no-console
    console.log(`[GA4] page_view: ${path}`, payload);
  }
  if (!hasGtag()) return;
  window.gtag("event", "page_view", payload);
};
